"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAuthoriser = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
// Events
const events_1 = require("../../features/events");
const challenges_constants_1 = require("../../features/authoriser/constants/challenges.constants");
// Helpers
const authoriser_helper_1 = require("../../features/authoriser/helpers/authoriser.helper");
const challengeUtils_1 = require("../../features/authoriser/utils/challengeUtils");
// Types
const types_1 = require("../../features/authoriser/types");
// IVR
const ivrModel_1 = require("../../features/authoriser/domain/models/ivrModel");
const events_2 = require("../../features/events");
const DEFAULT_CHALLENGE_STATE = {
    isChallengeLoading: false,
    isChallengeBlocked: false,
    isChallengeVerifying: false,
    challengeVerificationError: null,
    isChallengeVerificationSucceeded: false,
    isChallengeVerificationFailed: false,
    challengeRetryStatus: types_1.ChallengeRetryStatus.DEFAULT,
    ivrChallengeStatus: null,
    challengeData: null,
    challengesData: [],
    pastChallenges: [],
};
const DEFAULT_STATE = Object.assign({ isStarted: false, isFailed: false, isBlocked: false, isTrustedDeviceRequired: false, isReadyToFinish: false, isFinishing: false, isFinished: false, error: null }, DEFAULT_CHALLENGE_STATE);
class MbAuthoriser {
    constructor(eventBus, asyncConnectionMode = web_ui_framework_1.AsyncConnectionMode.WEBSOCKET) {
        this.challenge = null;
        this.pastChallenges = [];
        this.state = DEFAULT_STATE;
        this.progressId = null;
        this.asyncConnectionMode = asyncConnectionMode;
        this.eventBus = eventBus;
    }
    setChallengeFactory(challengeFactory) {
        this.challengeFactory = challengeFactory;
    }
    initializeAuthoriser(initData, originalRequest, url) {
        this.accessToken = initData.accessToken;
        const firstChallengeData = (0, challengeUtils_1.mapToChallenge)(initData);
        if (url && url !== '') {
            this.requestId = (0, authoriser_helper_1.hashRequestURL)(url);
        }
        this.setChallenge(firstChallengeData);
        return (0, events_1.publishInitialiseAuthoriserEvent)({ firstChallenge: firstChallengeData, originalRequest }, this.eventBus);
    }
    onInitAuthoriser(callback) {
        return (0, events_1.subscribeInitAuthoriserEvent)(callback, this.eventBus);
    }
    updateState(state) {
        this.state = Object.assign(Object.assign(Object.assign({}, this.state), state), { challengeData: this.challenge ? this.challenge.data : null, challengesData: this.getChallengesData(), pastChallenges: this.pastChallenges });
        (0, events_1.publishAuthoriserStateChangedEvent)(this.state, this.eventBus);
    }
    onStateChange(callback) {
        return (0, events_1.subscribeAuthoriserStateChangedEvent)(callback, this.eventBus);
    }
    setChallenge(data) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            if (this.challenge) {
                (_b = (_a = this.challenge).finish) === null || _b === void 0 ? void 0 : _b.call(_a);
                this.pastChallenges.push(this.challenge);
                this.updateState({ isChallengeVerificationSucceeded: false, isChallengeVerificationFailed: false, challengeVerificationError: null });
            }
            if (data.type === types_1.ChallengeType.NONE) {
                this.challenge = null;
                this.updateState({ isFinished: true, isReadyToFinish: true });
                return;
            }
            this.challenge = this.challengeFactory.getChallenge(data);
            this.progressId = data.progressId;
            if (!this.challenge) {
                this.updateState({ isFailed: true });
                return;
            }
            this.updateState({ isChallengeLoading: true, isStarted: true });
            yield ((_d = (_c = this.challenge).init) === null || _d === void 0 ? void 0 : _d.call(_c, this));
            this.updateState({ isChallengeLoading: false });
        });
    }
    get challenges() {
        return [...this.pastChallenges, this.challenge];
    }
    getChallengesData() {
        return this.challenges.map(challengeInstance => (challengeInstance === null || challengeInstance === void 0 ? void 0 : challengeInstance.data) || null);
    }
    verifyChallenge(value) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.challenge || ((_a = this.challenge) === null || _a === void 0 ? void 0 : _a.data.type) === types_1.ChallengeType.NONE) {
                return;
            }
            this.updateState({ isChallengeVerifying: true, isChallengeVerificationFailed: false });
            try {
                const nextChallengeData = yield this.challenge.doVerify(value);
                this.updateState({ isChallengeVerificationSucceeded: true });
                this.setChallenge(nextChallengeData);
            }
            catch (error) {
                if (error.message !== challenges_constants_1.TRUSTED_VERIFICATION_INCOMPLETE) {
                    this.updateState({ isChallengeVerificationFailed: true, challengeVerificationError: error });
                }
            }
            finally {
                this.updateState({ isChallengeVerifying: false });
            }
        });
    }
    retryChallenge() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const status = yield ((_b = (_a = this.challenge) === null || _a === void 0 ? void 0 : _a.doRetry) === null || _b === void 0 ? void 0 : _b.call(_a));
            if (status && status !== types_1.ChallengeRetryStatus.DEFAULT) {
                this.fail(status === types_1.ChallengeRetryStatus.LIMIT_EXCEEDED);
                this.updateState({ isChallengeBlocked: true, challengeRetryStatus: status });
            }
        });
    }
    fail(block = false, error) {
        this.updateState({ isFailed: true, isBlocked: block, isReadyToFinish: false, error });
    }
    noTrustedDevice() {
        this.updateState({ isTrustedDeviceRequired: true });
    }
    transferToChallengeIvr() {
        this.updateState({ isChallengeLoading: true });
        this.challenge.doTransfer();
    }
    subscribeIvrEvents() {
        const subscribers = {
            otpSuccessSubscriber: (callback) => (0, events_2.subscribeRaiseN2OTPIVRSuccessEvent)(callback, this.eventBus),
            otpErrorSubscriber: (callback) => (0, events_2.subscribeRaiseN2OTPIVRErrorEvent)(callback, this.eventBus),
            skSuccessSubscriber: (callback) => (0, events_2.subscribeRaiseN2IVRSuccessEvent)(callback, this.eventBus),
            skErrorSubscriber: (callback) => (0, events_2.subscribeRaiseN2IVRErrorEvent)(callback, this.eventBus),
        };
        // TODO: Challenge must be finished automatically, so agent should continue with operation
        subscribers.otpSuccessSubscriber((data) => {
            this.updateState({ ivrChallengeStatus: ivrModel_1.IVR_SUCCESS.SUCCESS });
            this.verifyChallenge(data);
            this.updateState({ isChallengeLoading: false });
        });
        subscribers.otpErrorSubscriber((error) => {
            this.updateState({ isChallengeLoading: false, ivrChallengeStatus: error });
        });
        subscribers.skSuccessSubscriber((data) => {
            this.updateState({ ivrChallengeStatus: ivrModel_1.IVR_SUCCESS.SUCCESS });
            this.verifyChallenge(data);
            this.updateState({ isChallengeLoading: false });
        });
        subscribers.skErrorSubscriber((error) => {
            this.updateState({ isChallengeLoading: false, ivrChallengeStatus: error });
        });
    }
    unsubscribeIvrEvents() {
        // TODO
    }
    reset() {
        var _a, _b;
        this.pastChallenges = [];
        this.requestId = null;
        const canRetryChallenge = this.state.isFailed && !this.state.isBlocked;
        if (canRetryChallenge) {
            this.updateState({
                isFailed: false,
                isBlocked: false,
                isChallengeBlocked: false,
                challengeRetryStatus: types_1.ChallengeRetryStatus.DEFAULT,
                isChallengeVerificationFailed: false,
                isChallengeVerificationSucceeded: false,
                ivrChallengeStatus: null,
            });
            return;
        }
        (_b = (_a = this.challenge) === null || _a === void 0 ? void 0 : _a.finish) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.challenge = null;
        this.progressId = null;
        this.accessToken = undefined;
        this.updateState(DEFAULT_STATE);
    }
}
exports.MbAuthoriser = MbAuthoriser;
//# sourceMappingURL=authoriser.js.map